import React, {Component} from 'react';
import PropTypes from "prop-types";
import styled from "styled-components";
import DetectionSquare from "./DetectionSquare"
import {getLocalizedString, getString, translations} from "../utils/translations"
import {OVER_TIME_FACE_DIRECTIONS, OVER_TIME_FACIAL_MUSCLES_BUTTONS, OVER_TIME_MODULES_BUTTONS, DETECTION_INTERVAL_MS} from "../constants"

import _, {findIndex} from "lodash";
import OverTimeChart from './Charts/OverTime';
import colors from "../styles/colors"
import VideoFaceDetector from "./VideoFaceDetector";
import VideoStream from "./VideoStream";
import Popup from "./Popup";

import {format} from "../views/Dashboard/TableData/utils"
import {setVideoTracker} from "../redux/videos"
import firebase from "../api/firebase";

import {connect} from "react-redux";

import {
    normalizeValue, handleDetectionResult, calculateEyebrowDirection
} from "../utils/bioFeedback"
import {detect, getDefaultOptions, landmarksWrapper, clearFaceIdMap, faceIdMap} from "solo-web-engine";
import {
    BLINK_FREQUENCY_DURATION_SECONDS,
    BLINK_FREQUENCY_FILTER_X_FIRST_SECONDS,
    VIDEO_BACKGROUND_PROCESSING_MIN_SECONDS,
    VIDEO_DASHBOARD_ENALBLE_REALTIME_ANALYSIS
} from "../api/remoteConfig";
import {
    calculateFrequencyPerMinute,
    detectBlink,
    videoDimensions
} from "solo-web-engine/src/bioFeedback";
import {addFaceId, resetFaceId, selectId, updateFaceIdCount} from "../redux/faceIdSlice";
import IdsButtons from "./Charts/OverTime/IdButtons";
import SoloOverTimeChart from "../views/Dashboard/SoloOverTimeChart";
import {getAsset} from "../utils";
import { saveTrackerChunk, finalizeVideoProcessing, getCompleteTrackerData } from "../api/solo";

const createInitialAnalysisProgress = () => ({
    mode: null,
    stage: null,
    frameIndex: 0,
    totalFrames: 0,
    currentTime: 0,
    duration: 0,
    batchIndex: 0,
    batchCount: 0,
    batchFrameIndex: 0,
    batchFrameCount: 0,
    batchStartTime: 0,
    batchDuration: 0,
    batchEtaSec: null,
    overallEtaSec: null,
    ffmpegSpeed: null,
    overallProgressPct: 0,
});

const getAnalysisString = (key, en, ja) => getLocalizedString(key, { en, ja });


class Video extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageWidth: 0,
            imageHeight: 0,
            detectionSquareTop: 0,
            detectionSquareLeft: 0,
            currentTime: 0,
            seconds: 0,
            noResultCount: 0,
            detectionsArray: [],
            input: null,
            overtime: [],
            previewOverTime: [],
            selectedButtons: [OVER_TIME_MODULES_BUTTONS.MOOD],
            videoSrc: null,
            videoPlaying: false,
            videoEnded: false,
            options: this.getOptions(props),
            backgroundAnalyzing: false,
            backgroundProcessingPercentage: 0,
            showFaceLandmarks: false,
            overtimeById: {},
            recordedVideoChunks: [],
            recordingReady: false,
            previewTracker: [],
            streamReady: false,
            countDown: 3,
            countingDown: false,
            warmupOffset: null,
            lastFrameTime: 0,
            fpsValues: [],
            currentFps: 0,
            tempVideoId: null,
            finilized: false,
            triggerFinalization: false,
            analysisProgress: createInitialAnalysisProgress(),
            showAnalysisVisibilityWarning: false,
        }

        // this.componentTimeOut = null
        this.videoElement = React.createRef()
        this.shouldDetectTimeOut = null
        this.detectTimeOut = null
        this._isMounted = false;
        this.countDownInterval = null;

        this.videoRef = React.createRef();
        this.lastUpdate = 0;
        this.timer = null;

        this.fpsUpdateInterval = null;
        this.wakeLockSentinel = null;
        this.wakeLockRequestInFlight = false;
        this.beforeUnloadWarningActive = false;
        this.analysisWasHidden = false;
    }

    getOptions = (props) => {
        return getDefaultOptions()
    }

    componentDidMount() {
        const {videoUrl, videoFile, setAnalyzing, previewMode} = this.props
        let videoSrc = videoFile ? URL.createObjectURL(videoFile) : videoUrl
        this.setState({videoSrc})
        this.setState({videoPlaying: true})
        this._isMounted = true;
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        setAnalyzing && setAnalyzing(true)
        if(previewMode){
            this.setState({showFaceLandmarks: true})
        }

        // Start FPS calculation update interval
        this.fpsUpdateInterval = setInterval(() => {
            if (this.state.fpsValues.length > 0) {
                const avgFps = this.state.fpsValues.reduce((sum, fps) => sum + fps, 0) / this.state.fpsValues.length;
                this.setState({
                    currentFps: Math.round(avgFps * 10) / 10,
                    fpsValues: [] // Reset for next interval
                });
            }
        }, 2000); // Update FPS display every 2 seconds

        // Generate a temporary video ID at the start of processing
        this.setState({
            tempVideoId: `temp_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`
        }, () => {
            console.log(`Generated temporary video ID: ${this.state.tempVideoId}`);
        });

        this.syncWakeLock();
        this.syncAnalysisBeforeUnloadWarning();
    }

    onAnalyzeEnd = async (callfrom) => {
        const {previewMode} = this.props
        console.log("onAnalyzeEnd", callfrom, this.state.tempVideoId, previewMode)

        const run = async () => {
            if(!previewMode && !this.state.finilized ){
                let video = await this.finalizeTrackerData();
                console.log("onAnalyzeEnd", video)
                this.props.onAnalyzeEnd(video)
            }
            this.setState({
                finilized: true,
                showAnalysisVisibilityWarning: false
            })
            this.analysisWasHidden = false;
            if(callfrom === "onFinishDetection"){
                this.props.setBackgroundProcessing(false)
            }
        }

        if(callfrom === "onFinishDetection"){
            if(this.props.videoFile){
                // File analysis via FFmpeg: no video element is playing, so video.onended never
                // fires and videoEnded stays false. Set it true before finalizing so that
                // finalizeTrackerData's guard condition passes.
                this.setState({ videoEnded: true }, () => run())
            } else if(!this.state.videoEnded){
                setTimeout(()=>{this.onAnalyzeEnd("onFinishDetection")}, 500)
            }else{
                run()
            }
        }else{
            console.log("onFinishDetection timeout")
            setTimeout(run, 1000)
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const {input} = this.state
        const {setAnalyzing, previewMode, videoAnalyzeForLiveStream} = this.props

        const video = document.getElementById('vid');

        if (video) {
            if (!input) {
                this.setState({input: video})
                this.currentDimensions()
            }
            video.onloadeddata = (event) => {
                console.log("onloadeddata")
                video.play()
            };
            video.onplay = (event) => {
                console.log("onplay")
                !previewMode && this.detectionLoop()
                if (this.state.videoEnded && !this.isUsingBackgroundProcessing()) {
                    console.log("Video ended setAnalyzing(false)");
                    this.setState({videoEnded: false})
                    !previewMode && setAnalyzing && setAnalyzing(false)
                }
                if(previewMode){
                    this.startSyncTimer()
                }

            };
            video.onpause = (event) => {
                console.log("onpause")
                if (!previewMode) {
                    clearTimeout(this.shouldDetectTimeOut)
                    clearTimeout(this.detectTimeOut)
                }
                this.setState({videoPlaying: false})
                this.stopSyncTimer()
            };
            video.onended = async (event) => {
                console.log("onended")
                if (!previewMode) {
                    clearTimeout(this.shouldDetectTimeOut)
                    clearTimeout(this.detectTimeOut)
                }
                this.setState({videoEnded: true, videoPlaying: false});
                this.stopSyncTimer();

                !previewMode && !this.isUsingBackgroundProcessing() && await this.onAnalyzeEnd("onended callback")
                !previewMode && setAnalyzing && setAnalyzing(false);
            };
            video.ontimeupdate = (event) => {
                if (previewMode) {
                    this.seekToDataAtTime(video.currentTime);
                }
            };
        }

        if (!videoAnalyzeForLiveStream && prevProps.videoAnalyzeForLiveStream) {
            clearTimeout(this.shouldDetectTimeOut)
            clearTimeout(this.detectTimeOut)
        }

        if (previewMode && !prevProps.previewMode) {
           // console.log("assignOverTimeData", this.state)
          //  this.assignOverTimeData(this.props.tracker)
            if(video){
                video.play()
            }

            this.setState({showFaceLandmarks: true})
        }

        // Handle manual finalization trigger from parent component
        if (this.props.triggerFinalization && !prevProps.triggerFinalization) {
            this.handleManualFinalization();
        }

        if (
            prevProps.videoFile !== this.props.videoFile ||
            prevProps.previewMode !== this.props.previewMode ||
            prevState.finilized !== this.state.finilized
        ) {
            this.syncWakeLock();
        }
        this.syncAnalysisBeforeUnloadWarning();
    }

    isUploadAnalysisActive = () => {
        const { previewMode, videoFile } = this.props;
        const { finilized } = this.state;
        return !!videoFile && !previewMode && !finilized;
    }

    getAnalysisCloseWarningMessage = () => (
        getAnalysisString(
            "analysis_close_warning_message",
            "Video analysis is still running. Closing or reloading this page will stop the analysis.",
            "動画分析はまだ実行中です。このページを閉じたり再読み込みしたりすると、分析が停止します。"
        )
    )

    handleBeforeUnload = (event) => {
        if (!this.isUploadAnalysisActive()) {
            return undefined;
        }

        const message = this.getAnalysisCloseWarningMessage();
        event.preventDefault();
        // Modern browsers show a generic string, but returnValue is still needed for legacy support.
        event.returnValue = message;
        return message;
    }

    syncAnalysisBeforeUnloadWarning = () => {
        const shouldWarn = this.isUploadAnalysisActive();
        if (shouldWarn && !this.beforeUnloadWarningActive) {
            window.addEventListener('beforeunload', this.handleBeforeUnload);
            this.beforeUnloadWarningActive = true;
        } else if (!shouldWarn && this.beforeUnloadWarningActive) {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
            this.beforeUnloadWarningActive = false;
        }
    }

    shouldKeepScreenAwake = () => {
        const { previewMode, videoFile } = this.props;
        const { finilized } = this.state;
        return !!videoFile && !previewMode && !finilized;
    }

    requestWakeLock = async () => {
        if (
            this.wakeLockSentinel ||
            this.wakeLockRequestInFlight ||
            !this.shouldKeepScreenAwake() ||
            typeof navigator === 'undefined' ||
            !navigator.wakeLock ||
            document.visibilityState !== 'visible'
        ) {
            return;
        }

        this.wakeLockRequestInFlight = true;
        try {
            const sentinel = await navigator.wakeLock.request('screen');
            sentinel.addEventListener('release', this.handleWakeLockRelease);
            this.wakeLockSentinel = sentinel;
            console.log('[Video] Screen wake lock acquired');
        } catch (error) {
            console.warn('[Video] Screen wake lock unavailable:', error);
        } finally {
            this.wakeLockRequestInFlight = false;
        }
    }

    releaseWakeLock = async () => {
        const sentinel = this.wakeLockSentinel;
        this.wakeLockSentinel = null;

        if (!sentinel) {
            return;
        }

        try {
            sentinel.removeEventListener('release', this.handleWakeLockRelease);
            await sentinel.release();
            console.log('[Video] Screen wake lock released');
        } catch (error) {
            console.warn('[Video] Failed to release screen wake lock:', error);
        }
    }

    handleWakeLockRelease = () => {
        this.wakeLockSentinel = null;
        if (this.shouldKeepScreenAwake() && document.visibilityState === 'visible') {
            this.requestWakeLock();
        }
    }

    handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            if (this.isUploadAnalysisActive()) {
                this.analysisWasHidden = true;
            }
        } else if (document.visibilityState === 'visible') {
            if (this.analysisWasHidden && this.isUploadAnalysisActive()) {
                this.setState({showAnalysisVisibilityWarning: true});
            }
            this.analysisWasHidden = false;
        }
        this.syncWakeLock();
    }

    handleCloseAnalysisVisibilityWarning = () => {
        this.setState({showAnalysisVisibilityWarning: false});
    }

    syncWakeLock = () => {
        if (this.shouldKeepScreenAwake()) {
            this.requestWakeLock();
            return;
        }

        this.releaseWakeLock();
    }

    startSyncTimer = () => {
        this.stopSyncTimer(); // Ensure any existing timer is cleared
        this.timer = setInterval(() => {
            if (this.props.previewMode) {
                const currentTime = this.videoElement.current.currentTime;
                this.seekToDataAtTime(currentTime);
            }
        }, DETECTION_INTERVAL_MS);
    }

    stopSyncTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }


    componentWillUnmount() {
        console.log("componentWillUnmount")

        clearTimeout(this.shouldDetectTimeOut)
        clearTimeout(this.detectTimeOut)

        this._isMounted = false;
        const videoElement = this.videoElement.current;
        if (videoElement) {
            videoElement.removeEventListener('play', this.startSyncTimer);
            videoElement.removeEventListener('pause', this.stopSyncTimer);
            videoElement.removeEventListener('ended', this.stopSyncTimer);
        }
        this.stopSyncTimer();
        //clearTimeout(this.componentTimeOut);
        clearFaceIdMap()
        this.props.resetFaceId()
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.beforeUnloadWarningActive = false;
        this.releaseWakeLock();

        clearInterval(this.fpsUpdateInterval);
    }

    onRecordingComplete = (recordedChunks) => {
        console.log("playing recorded video", this.state.recordedVideoChunks)
        const blob = new Blob(recordedChunks, {type: 'video/webm'});
        const url = URL.createObjectURL(blob);
        this.setState({videoSrc: url})
    }

    seekToDataAtTime = (time) => {
        this.alterOvertimeData(time)
        this.setDetectionArrayByTime(time)
    }

    assignOverTimeData = (tracker) => {
     let state = {
         overtime: [],
         overtimeById: {}
     }


        tracker.forEach((item, index) => {
            //   console.log("assignOverTimeData", item)
            state = this.pushToOverTime(item.result, item.currentTime, state)

        })
        //console.log("assignOverTimeData", state)
        this.setState(state)


    }

    alterOvertimeData(currentTime) {
        const filteredOvertime = this.state.overtime.filter(item => item.timeSpent <= currentTime * 1000);
        this.setState({previewOverTime: filteredOvertime});
    }

    setDetectionArrayByTime = (time) => {
    //    console.log("setDetection frame time", time)
        const {previewTracker, showFaceLandmarks} = this.state

        if (!previewTracker || previewTracker.length === 0) return;

        let detectionArray = previewTracker.filter(d => d.currentTime <= time && time - d.currentTime <= 0.2);
        // get last item from detectionArray (closest to frame time)

        const lastItem = _.last(previewTracker);
        let timeFromLastFrame = lastItem ? lastItem.currentTime - time : 0;
        let validLastFrame = _.get(lastItem, "emotions.mood") !== null

        if (detectionArray.length > 0) {
            let sorted = detectionArray.sort((a, b) => b.currentTime - a.currentTime)
            detectionArray = sorted[0]
            this.setState({detectionsArray: detectionArray.result})
           // console.log("setDetection result time", {videoTime: time, trackerTime: detectionArray.currentTime}, detectionArray)
            if(showFaceLandmarks && detectionArray.faceMeshResult ){
               // console.log("render blendshapes", Date.now(), detectionArray.currentTime)
               landmarksWrapper.drawResults(detectionArray.faceMeshResult, document.getElementById('canvas-overlay'), document.getElementById('vid'))
            }else {
                landmarksWrapper.clearResults()
            }
        } else {
            if(timeFromLastFrame < 0.2 && validLastFrame){
              //  console.log("timeFromLastFrame", {videoTime: time, trackerTime: _.last(previewTracker).currentTime, timeFromLastFrame}, _.last(previewTracker))
                this.setState({detectionsArray: []})
            }
        }

    }

    currentDimensions = () => {
        if (this.videoElement.current) {
            this.setState({
                imageWidth: this.videoElement.current.offsetWidth,
                imageHeight: this.videoElement.current.offsetHeight,
                detectionSquareTop: this.videoElement.current.offsetTop,
                detectionSquareLeft: this.videoElement.current.offsetLeft
            })
        }
    }

    shouldDetectEmotions = () => {
        const {videoPlaying} = this.state
        const {previewMode} = this.props
        if (!previewMode && videoPlaying) {
            return true
        }
        return false
    }
    detectEmotions = async () => {

        if (!this._isMounted) {
            return;
        }

        const {detectionInterval, useMaskModel} = this.props
        const {input, options, countingDown, warmupOffset} = this.state

        try {

            let currentTime = this.videoElement.current && this.videoElement.current.currentTime
            if(warmupOffset){
                currentTime = currentTime - warmupOffset
            }

            const {detectionsWithExpressions, faceMeshResult} = await detect(input, {
                emotionsModelActive: true,
                handsModelActive: true,
                maskModelActive: useMaskModel,
                showFaceLandmarks: {
                    show: this.state.showFaceLandmarks,
                    canvas: document.getElementById('canvas-overlay')
                },
                emotionsModelOptions: options,
                returnOriginalFacemesh: true,
                sizeFilter: true,


            })

            if(!countingDown){
                const fps = this.calculateFps();
                console.log("detectEmotions", {
                    fps: fps ? Math.round(fps * 10) / 10 : 'initializing',
                    averageFps: this.state.currentFps || 'calculating',
                    detectionsWithExpressions,
                    faceMeshResult,
                    currentTime
                });
                let trackerItem = handleDetectionResult(detectionsWithExpressions, currentTime)

                this.setPlayerState(trackerItem.result, currentTime, trackerItem.result)
                //if (this.props.videoAnalyzeForLiveStream) {
                    this.saveResults({
                        emotions: trackerItem.emotions,
                        currentTime,
                        result: trackerItem.result,
                        fps: this.state.currentFps
                    })
               // }
            }

            if (this.shouldDetectEmotions()) {
                this.detectTimeOut = setTimeout(() => this.detectEmotions(), detectionInterval)
            }
        } catch (e) {
            console.log("error", e)
        }
    }

    detectionLoop = async (interval = 0) => {

        try {
            await this.detect();

            if (this.shouldDetectEmotions()) {
                //requestAnimationFrame(this.detectionLoop)
                this.detectTimeOut = setTimeout(() => this.detectionLoop(interval), interval)
            }
        } catch (e) {
            console.log("error", e)
        }
    }

    detect = async () => {
        try {
            const {
                ts,
                result,
                faceMeshResult,
                currentTime
            } = await this.analyzeFrame();

            let trackerItem = handleDetectionResult(result, ts);
            const fps = this.calculateFps();


            this.setPlayerState(trackerItem.result, currentTime, trackerItem.result);

            // Only call saveResults if the VideoFaceDetector is not active
            if (!this.isUsingBackgroundProcessing()) {
                this.saveResults({
                    emotions: trackerItem.emotions,
                    currentTime: currentTime,
                    result: trackerItem.result,
                    fps: this.state.currentFps
                })
            }
        } catch (e) {
            console.log("error", e)
        }
    }

    async analyzeFrame() {

        const { input, options} = this.state
        const {useMaskModel} = this.props
        const ts = Date.now()
        let currentTime = this.videoElement.current && this.videoElement.current.currentTime

        const {detectionsWithExpressions, faceMeshResult} = await detect(input, {
            emotionsModelActive: true,
            maskModelActive: useMaskModel,
            handsModelActive: true,
            detectLightingLevels: true,
            showFaceLandmarks: {
                show: this.state.showFaceLandmarks,
                canvas: document.getElementById('canvas-overlay')
            },
            emotionsModelOptions: options,
            returnOriginalFacemesh: true,
        })

        // console.log("onresult", result)
        return {ts, result: detectionsWithExpressions, faceMeshResult, currentTime};
    }

    setPlayerState = (emotions, currentTime, detectionsArray) => {
        this.pushToOverTime(emotions, currentTime)
        this.setState({detectionsArray})
    }

    saveResults = async ({currentTime, result, emotions, fps}) => {
        const {setVideoTracker, tracker} = this.props;

        // Use spread operator for shallow copy instead of deep clone
        let updatedTracker = [...tracker];
        let previewTracker = [...this.state.previewTracker];

        let trackerItem = {
            currentTime,
            result,
            emotions,
            fps: this.state.currentFps
        };

        // Check for duplicates
        let index = findIndex(updatedTracker, {currentTime: currentTime});
        if(index !== -1){
            console.log("duplicate item at ", currentTime);
            return;
        }

        updatedTracker.push(trackerItem);

        // Log FPS with every saved result
      //  console.log(`Saved result at ${currentTime}s - Current FPS: ${this.state.currentFps || 'calculating'} - Items in tracker: ${updatedTracker.length}`);

        // Determine if we need to offload data
        const CHUNK_SIZE = this.calculateChunkSize(updatedTracker);
        const OFFLOAD_THRESHOLD = CHUNK_SIZE * 2;

        if (updatedTracker.length > OFFLOAD_THRESHOLD) {
            // Keep the most recent CHUNK_SIZE items (30 seconds)
            const dataToOffload = updatedTracker.slice(0, updatedTracker.length - CHUNK_SIZE);
            const newTracker = updatedTracker.slice(updatedTracker.length - CHUNK_SIZE);

            // Use our API function to offload data
            if (dataToOffload.length >= 10) {
                this.offloadDataToServer(dataToOffload)
                    .then(() => {
                        console.log(`Offloaded ${dataToOffload.length} tracker items`);
                    })
                    .catch(error => {
                        console.error("Failed to offload data:", error);
                    });
            }
            updatedTracker = newTracker;
        }

        setVideoTracker(updatedTracker);

        // Handle preview tracker similarly - store faceMeshResult in preview tracker for rendering
        // but we're not sending it to the server anymore
        let newTrackerItem = {
            ...trackerItem
        };
        previewTracker.push(newTrackerItem);

        // Also trim the preview tracker
        if (previewTracker.length > OFFLOAD_THRESHOLD) {
            previewTracker = previewTracker.slice(previewTracker.length - CHUNK_SIZE);
        }

        this.setState({previewTracker});
    }

    isUsingBackgroundProcessing = () => {

        const { previewMode, videoFile } = this.props;

        if (previewMode) return false;

        // File uploads always use FFmpeg-based background processing
        if (videoFile) return true;

        const videoDuration = this.videoElement.current ? this.videoElement.current.duration : 0;

        if (isNaN(videoDuration)) return false;

        if (!VIDEO_DASHBOARD_ENALBLE_REALTIME_ANALYSIS) return true;

        return (videoDuration < VIDEO_BACKGROUND_PROCESSING_MIN_SECONDS);
    }


    calculateChunkSize = (tracker) => {
        // Find items within the last 30 seconds based on actual timestamps
        if (!tracker || tracker.length === 0) return 60; // Default if no data yet

        const latestTime = tracker[tracker.length - 1].currentTime;
        const thirtySecondsAgo = Math.max(0, latestTime - 30);

        // Count how many items fall within the last 30 seconds
        let count = 0;
        for (let i = tracker.length - 1; i >= 0; i--) {
            if (tracker[i].currentTime >= thirtySecondsAgo) {
                count++;
            } else {
                break; // We've gone beyond 30 seconds back
            }
        }

        // Ensure we have a reasonable minimum
        return 60//Math.max(count, 60); // At least 60 items or whatever makes sense for your app
    }

    offloadDataToServer = async (dataChunk) => {
        try {
            const { tempVideoId } = this.state;
            if (!tempVideoId) {
                console.error("No temporary video ID available");
                return { success: false, error: "Missing temporary ID" };
            }

            // Track which chunks we've offloaded for retrieval later
            if (!this.offloadedChunks) this.offloadedChunks = [];
            const chunkId = `${tempVideoId}_chunk_${this.offloadedChunks.length}`;

            // Call our API function with the temporary ID
            const result = await saveTrackerChunk(tempVideoId, chunkId, dataChunk);

            if (result.success) {
                this.offloadedChunks.push(chunkId);
                console.log(`Successfully offloaded chunk ${chunkId} with ${dataChunk.length} items`);
                return result;
            } else {
                throw new Error(result.error || 'Unknown error offloading data');
            }
        } catch (error) {
            console.error("Error offloading data:", error);
            throw error;
        }
    }

    retrieveCompleteData = async (tempVideoId) => {
        try {
            if (!tempVideoId) {
                throw new Error("No temporary video ID available");
            }
            // Use our API function that leverages caching
            const result = await getCompleteTrackerData(tempVideoId, true);

            if (result.success) {
                let trackerData = null;

                if(result.data) {
                    console.log(`Retrieved complete data for video ${tempVideoId}: ${result.data.length} items`);
                    trackerData = result.data;
                } else if(result.trackerPath) {
                    console.log("Downloading tracker from Firebase Storage path:", result.trackerPath);

                    try {
                        // Get download URL from Firebase Storage
                        const downloadURL = await firebase.storage().ref(result.trackerPath).getDownloadURL();
                        console.log("Got download URL:", downloadURL);

                        // Fetch the JSON file using the download URL
                        const response = await fetch(downloadURL);

                        if (!response.ok) {
                            throw new Error(`Failed to download tracker: ${response.status} ${response.statusText}`);
                        }

                        trackerData = await response.json();
                        console.log(`Downloaded tracker data from storage: ${trackerData.length} items`);
                    } catch (downloadError) {
                        console.error("Error downloading tracker from storage:", downloadError);
                        throw downloadError;
                    }
                }

                if (trackerData) {
                    // Process the tracker data into overtime format
                    let overTime = this.processOverTimeData(trackerData);

                    this.setState({
                        previewTracker: trackerData,
                        previewOverTime: overTime,
                        overtime: overTime,
                    });

                    return trackerData;
                } else {
                    throw new Error("No tracker data available");
                }
            } else {
                throw new Error(result.error || 'Unknown error retrieving data');
            }
        } catch (error) {
            console.error("Error retrieving complete data:", error);
            throw error;
        }
    }

    processOverTimeData = (data) => {
        // This function should transform tracker data to the overtime format
        // If you already have this implemented elsewhere, call that instead
        let overtime = [];
        let overtimeById = {};
        let state = {
            overtime,
            overtimeById
        }

        if (data && data.length > 0) {
            data.forEach(item => {
                if (item.result && item.currentTime) {
                    state = this.pushToOverTime(item.result, item.currentTime, state)
                }
            });
        }

        return state.overtime;
    }

    finalizeTrackerData = async (force = false) => {
        const { videoEnded, previewTracker, tempVideoId } = this.state;
        const { tracker, title, date, videoAnalyzeForLiveStream } = this.props;

        if (force && (tracker.length > 0 || previewTracker.length > 0) || (videoEnded && (tracker.length > 0 || previewTracker.length > 0))) {
            try {
                // Offload any remaining data
                if (tracker.length > 0) {
                    await this.offloadDataToServer(tracker);
                }

                // Calculate video duration in seconds
                let seconds = 0;

                // For live streams, use the last tracker item's timestamp
                if (videoAnalyzeForLiveStream) {
                    // Use the latest timestamp from either tracker or previewTracker
                    const trackerLastTime = tracker.length > 0 ? tracker[tracker.length - 1].currentTime : 0;
                    const previewLastTime = previewTracker.length > 0 ? previewTracker[previewTracker.length - 1].currentTime : 0;
                    seconds = Math.max(trackerLastTime, previewLastTime);

                    console.log(`Live stream duration calculated from tracker: ${seconds}s`);
                } else {
                    // For regular videos, prefer the video element's duration
                    const elementDuration = this.videoElement.current ? this.videoElement.current.duration : NaN;
                    if (elementDuration && !isNaN(elementDuration)) {
                        seconds = elementDuration;
                        console.log(`Video duration from element: ${seconds}s`);
                    } else {
                        // Fallback: derive from the last tracker item (e.g. when video element isn't present)
                        const trackerLastTime = tracker.length > 0 ? tracker[tracker.length - 1].currentTime : 0;
                        const previewLastTime = previewTracker.length > 0 ? previewTracker[previewTracker.length - 1].currentTime : 0;
                        seconds = Math.max(trackerLastTime, previewLastTime);
                        console.log(`Video duration derived from tracker: ${seconds}s`);
                    }
                }

                // Signal to server that processing is complete AND save the video in one step
                console.log("finalizeTrackerData", tempVideoId, title, date, seconds);
                const result = await finalizeVideoProcessing(tempVideoId, title, date, seconds);
                console.log("finalization result", result);

                if (result.success) {
                    console.log(`Finalized and saved processing for video ${tempVideoId}`);

                    // Update videoId to use the tempVideoId for retrieving data
                    this.setState({
                        videoId: tempVideoId,
                        previewMode: true // Automatically enter preview mode after finalization
                    });

                    //this.onAnalyzeEnd("finalizeTrackerData", result.video)

                    // Notify parent component that analysis is complete and we're in preview mode
                    //this.props.onAnalyzeEnd && this.props.onAnalyzeEnd(result.video );

                    return result.video;
                } else {
                    throw new Error(result.error || 'Unknown error finalizing data');
                }
            } catch (error) {
                console.error("Error finalizing tracker data:", error);
                return false;
            }
        }
        return false;
    }

    calculateFps() {
        const now = performance.now();
        if (this.state.lastFrameTime > 0) {
            const timeDiff = now - this.state.lastFrameTime; // ms
            const fps = 1000 / timeDiff;

            // Add to rolling average
            const fpsValues = [...this.state.fpsValues, fps].slice(-10); // Keep last 10 values
            this.setState({ fpsValues, lastFrameTime: now });

            return fps;
        }

        this.setState({ lastFrameTime: now });
        return null;
    }

    handleManualFinalization = async () => {
        try {
            // Only proceed if we're not already finalized and not in preview mode
            if (!this.state.finilized && !this.props.previewMode) {
                console.log("Manual finalization triggered");

                // Force setting videoEnded to true so finalization can proceed
                this.setState({ videoEnded: true, videoPlaying: false }, async () => {
                    // Perform the finalization
                    let video = await this.finalizeTrackerData();

                    // Notify parent that finalization is complete
                    this.props.onFinalizationComplete && this.props.onFinalizationComplete();

                    // Trigger analyze end callback
                    this.props.onAnalyzeEnd && this.props.onAnalyzeEnd(video);

                    // Mark as finalized
                    this.setState({ finilized: true });
                });



            }
        } catch (error) {
            console.error("Error during manual finalization:", error);
            this.props.onFinalizationComplete && this.props.onFinalizationComplete();
        }
    }

    addSuffix = (key, suffix) => {
        if(suffix){
            return key + "_" + suffix
        }
        return key
    }

    getOTBlendshapesFromTrackerItem = (item, suffix = null) => {
        let blendshapes = {
            jawOpen: null,
            mouthPucker: null,
            browsDown: null,
            browsOuterUp: null,
            eyesBlink: null,
            eyesSquint: null,
            eyesLookDown: null,
            eyesLookRight: null,
            eyesLookLeft: null,
            eyesLookHorizontal: null,
            eyesLookVertical: null,
            eyesLookUp: null,
            mouthUpperUp: null,
        }

        if (item && item.faceBlendshapes) {
            for (const key in item.faceBlendshapes) {
                blendshapes[key] = normalizeValue(item.faceBlendshapes[key])
            }
        }
        if(suffix){
            for (const key in blendshapes) {
                blendshapes[this.addSuffix(key, suffix)] = blendshapes[key]
                delete blendshapes[key]
            }
        }

        // calaculate eyesLookHorizontal and eyesLookVertical
        if (blendshapes.eyesLookRight && blendshapes.eyesLookLeft) {
            blendshapes.eyesLookHorizontal = (blendshapes.eyesLookRight - blendshapes.eyesLookLeft) / 2
        }

        if (blendshapes.eyesLookUp && blendshapes.eyesLookDown) {
            blendshapes.eyesLookVertical = (blendshapes.eyesLookUp - blendshapes.eyesLookDown) / 2
        }

        return blendshapes
    }

    pushToOverTime = (data, currentTime, state) => {
        //console.log("pushToOverTime", data, currentTime)
        const {overtime, overtimeById} = state ? state : this.state
        let updatedOvertime = [...overtime]
        const clonedOvertimeById = _.cloneDeep(overtimeById)

        let index = format(currentTime);

        let item = {}
        let generalItem = {}

        for (let i = 0; i < data.length; i++) {
            // console.log("pushToOverTime", i, data[i])
            let d = data[i]

            let yawnRatio = d.faceBlendshapes ? Math.round(d.faceBlendshapes.jawOpen * 100) : null;
            let eyebrowEyeRatio = d.faceBlendshapes ? calculateEyebrowDirection(d.faceBlendshapes.browsOuterUp, d.faceBlendshapes.browsDown) : null;
            let frownScore = d.frown ? (d.frown.frownScore) - 200 : null
            let pitchAngle = d.headPose ? d.headPose.pitch : null
            let noseEyebrowRatio = d.frown ? d.frown.noseEyebrowRatio : null;
            let yawAngle = (d.headPose ? d.headPose.yaw : null);
            let eyesBlink = d.faceBlendshapes ? d.faceBlendshapes.eyesBlink : null;

            let yawFallback = d.headAnglesFallback ? d.headAnglesFallback.yaw : null;
            let pitchFallback = d.headAnglesFallback ? d.headAnglesFallback.pitch : null;
            let rollFallback = d.headAnglesFallback ? d.headAnglesFallback.roll : null;


            if (yawnRatio > 100) {
                yawnRatio = 100
            }

            if (frownScore > 100) {
                frownScore = 100
            } else if (frownScore < 0) {
                frownScore = 0
            }

            if (noseEyebrowRatio > 350) {
                noseEyebrowRatio = 350
            } else if (noseEyebrowRatio < 300) {
                noseEyebrowRatio = 300
            }

            let blendshapes = this.getOTBlendshapesFromTrackerItem(d, d.id)

            const filterReason = d.filterReason || null;
            const filterEmotions = Boolean(d.toFilter || filterReason);

            item = {
                ...item,
                index,
                timeSpent: currentTime * 1000,
                id: d.id,
                [`filterReason_${d.id}`]: filterReason,
                [`mood_${d.id}`]: !filterEmotions ? normalizeValue(d.valence) : null,
                [`energy_${d.id}`]: !filterEmotions ? normalizeValue(d.energy) : null,
                [`wellbeing_${d.id}`]: !filterEmotions ? normalizeValue(d.wellbeing) : null,
                [`engagement_${d.id}`]: !filterEmotions ? normalizeValue(d.engagement) : null,
                [`interest_${d.id}`]: !filterEmotions ? normalizeValue(d.interest) : null,
                [`stress_${d.id}`]: !filterEmotions ? normalizeValue(d.stress) : null,
                [`closedEyes_${d.id}`]: eyesBlink !== null ? (eyesBlink) * 100 : null ,
                [`yawn_${d.id}`]:  normalizeValue(d.yawn),
                [`yawnRatio_${d.id}`]: yawnRatio ,
                [`mask_${d.id}`]:  normalizeValue(d.mask),
                [`noMask_${d.id}`]:  normalizeValue(d.noMask),
                [`closedLeftEye_${d.id}`]:  normalizeValue(d.closedLeftEye),
                [`openLeftEye_${d.id}`]:  normalizeValue(d.openLeftEye),
                [`closedRightEye_${d.id}`]:  normalizeValue(d.closedRightEye),
                [`openRightEye_${d.id}`]:  normalizeValue(d.openRightEye),
                [`openEyes_${d.id}`]:  eyesBlink !== null ? (1 - eyesBlink) * 100 : null,
                [`yawAngle_${d.id}`]: yawAngle,
                [`pitchAngle_${d.id}`]: pitchAngle,
                [`eyebrowEyeRatio_${d.id}`]: !filterEmotions ? eyebrowEyeRatio : null,
                [`frownScore_${d.id}`]: !filterEmotions ? frownScore : null,
                [`noseEyebrowRatio_${d.id}`]: !filterEmotions ? noseEyebrowRatio : null,
                [`eyesBlink_${d.id}`]: !filterEmotions ? eyesBlink : null,
                [`yawFallback_${d.id}`]: yawFallback,
                [`pitchFallback_${d.id}`]: pitchFallback,
                [`rollFallback_${d.id}`]: rollFallback,
                ...blendshapes
            }

            generalItem = {
                ...item,
                index,
                timeSpent: currentTime * 1000,
                id: d.id,
                filterReason,
                [`mood`]: !filterEmotions ? normalizeValue(d.valence) : null,
                [`energy`]: !filterEmotions ? normalizeValue(d.energy) : null,
                [`wellbeing`]: !filterEmotions ? normalizeValue(d.wellbeing) : null,
                [`engagement`]: !filterEmotions ? normalizeValue(d.engagement) : null,
                [`interes}`]: !filterEmotions ? normalizeValue(d.interest) : null,
                [`stress`]: !filterEmotions ? normalizeValue(d.stress) : null,
                [`closedEyes`]:  (eyesBlink) * 100,
                [`yawn`]:  normalizeValue(d.yawn),
                [`yawnRatio`]:  yawnRatio,
                [`mask`]:  normalizeValue(d.mask),
                [`noMask`]:  normalizeValue(d.noMask),
                [`closedLeftEye`]:  normalizeValue(d.closedLeftEye),
                [`openLeftEye`]:  normalizeValue(d.openLeftEye),
                [`closedRightEye`]:  normalizeValue(d.closedRightEye),
                [`openRightEye`]:  normalizeValue(d.openRightEye),
                [`openEyes`]:  (1 - eyesBlink) * 100,
                [`yawAngle`]: yawAngle,
                [`pitchAngle`]: pitchAngle,
                [`eyebrowEyeRatio`]:  eyebrowEyeRatio,
                [`frownScore`]:  frownScore,
                [`noseEyebrowRatio`]:  noseEyebrowRatio,
                [`eyesBlink`]:  eyesBlink,
                frown: {
                    ...item.frown,
                    eyebrowEyeRatio,
                    frownScore,
                    noseEyebrowRatio,
                },
                yawFallback,
                pitchFallback,
                rollFallback
            }


            if (overtimeById[d.id]) {
                clonedOvertimeById[d.id].push(generalItem)
            } else {
                clonedOvertimeById[d.id] = [generalItem]
            }


            let blink = detectBlink(clonedOvertimeById[d.id], d.id)
            //console.log("blink", blink)
            item[`blink_${d.id}`] = blink
            clonedOvertimeById[d.id][clonedOvertimeById[d.id].length - 1].blink = blink
            clonedOvertimeById[d.id][clonedOvertimeById[d.id].length - 1][`blink_${d.id}`] = blink


            let blinksPM = calculateFrequencyPerMinute(clonedOvertimeById[d.id], `blink_${d.id}`, BLINK_FREQUENCY_DURATION_SECONDS, BLINK_FREQUENCY_FILTER_X_FIRST_SECONDS)
            //console.log("blinksPM", blinksPM)
            // console.log("blink", blink)
            // console.log("blinksPM", blinksPM)
            item[`blinksPM_${d.id}`] = blinksPM
            clonedOvertimeById[d.id][clonedOvertimeById[d.id].length - 1].blinksPM = blinksPM


            // console.log("overtime item", generalItem.eyebrowEyeRatio)


            /* let blink = detectBlink(state.overtimeById[d.id], d.id)
             item[`blink_${d.id}`] = blink

             let blinksPM = calculateFrequencyPerMinute(state.overtimeById[d.id], `blink_${d.id}`, BLINK_FREQUENCY_DURATION_SECONDS, BLINK_FREQUENCY_FILTER_X_FIRST_SECONDS)

             item[`blinksPM_${d.id}`] = blinksPM*/
            if (!state) {
                this.setState({overtimeById: clonedOvertimeById})
            }

        }
        updatedOvertime.push(item)

        // console.log("updatedOvertime", item)

        if (!state) {
            this.setState({overtime: updatedOvertime})
        } else {
            return {
                overtime: updatedOvertime,
                overtimeById: clonedOvertimeById
            }
        }

    }

    renderDetectionSquare = (height, width, vidCurrTime, data) => {

        const {detectionsArray} = this.state
        const {previewMode, videoAnalyzeForLiveStream} = this.props
        let result = _.cloneDeep(detectionsArray)
        // const result = data.filter(d => d.currentTime === vidCurrTime) //from state - video upload processed in server

      //  console.log("renderDetectionSquare", result)
        //console.log("renderDetectionSquare", Date.now(), videoAnalyzeForLiveStream)
        let map = result.map(r => { //d
                // let r = (d.result[0])
                let dominantEmotion = this.getDominantEmotion(r)
                let emphasizeDetection = true

            let frame = performance.now()

            if(!r.stressLevel){
                return null;
            }

            let boxOnly = true
            if((previewMode || videoAnalyzeForLiveStream) && r.stress !== null){
                boxOnly = false
            }

                return <DetectionSquare
                    id={r.id}
                    frame={frame}
                    emphasize={emphasizeDetection}
                    percentage={dominantEmotion.value}
                    label={getString(dominantEmotion.label)}
                    progressColor={dominantEmotion.color}
                    top={(r.detection._box._y / (r.detection._imageDims._height / height)) - 15}
                    left={r.detection._box._x / (r.detection._imageDims._width / width) - 10}
                    width={r.detection._box._width / (r.detection._imageDims._width / width) + 15}
                    height={(r.detection._box._height / (r.detection._imageDims._height / height)) + 5}
                    extendedDetectionSquare={true}
                    stressLevel={r.stressLevel}
                    interestLevel={r.interestLevel}
                    engagementLevel={r.engagementLevel}
                    wellbeingLevel={r.wellbeingLevel}
                    boxOnly={boxOnly}
                />
            }
        );

        // console.log("map", map)
        return map
    }

    getDominantEmotion = (detection) => {
        const expressionsArr = []

        for (const expression in detection.expressions) {
            if (typeof detection.expressions[expression] === "number") {
                const color = this.detectEmotionColor(expression)
                const value = Math.round(detection.expressions[expression] * 100)
                expressionsArr.push({label: expression, color, value})
            }
        }

        //console.log("expressionsArr", expressionsArr)

        if(expressionsArr.length === 0){
            return {label: "", color: "#fff", value: 100}
        }
        const maxObject = expressionsArr.reduce(function (prev, current) {
            return (prev.value > current.value) ? prev : current
        })

        return maxObject
    }

    detectEmotionColor = (expression) => {
        switch (expression) {
            case 'happy':
                return "#FFBD58"
            case 'neutral':
                return "#6FCF97"
            case 'sad':
                return "#EB5757"
            case 'angry':
                return "#000000"
            case 'disgusted':
                return "#828282"
            case 'fearful':
                return "#BB6BD9"
            case 'surprised':
                return "#56CCF2"
            default:
                return "#6FCF97"
        }
    }

    renderOvertimeChart = () => {
        const {selectedButtons, overtime, previewOverTime, showFaceLandmarks} = this.state
        const {faceIds, selectedIds, previewMode, faceIdCount, selectId, videoAnalyzeForLiveStream} = this.props

        if (this.isUsingBackgroundProcessing()) {
           // if(!videoAnalyzeForLiveStream){
               return null;
           // }
        }

        let modified = previewMode ? [...previewOverTime] : [...overtime]

        //console.log("renderOvertimeChart", modified)

        return <SoloOverTimeChart
            overtime={modified}
            faceIds={faceIds}
            faceIdCount={faceIdCount}
            selectedIds={selectedIds}
            showBrush={false}
            onBrushChange={()=>{}}
            toggleFaceLandmarks={this.toggleFaceLandmarks}
            resetOverTime={null}
            selectId={selectId}
            showFaceLandmarks={showFaceLandmarks}
            isJP={translations.selectedLocale === "ja"}
            showAll={previewMode ? true : false}
            showPartTime={previewMode ? 30 : 5}
        />

    }

    toggleFaceLandmarks = () => {
        const {showFaceLandmarks} = this.state
        this.setState({showFaceLandmarks: !showFaceLandmarks})
    }

    renderFooter = () => {
        let percentage = 0
        const video = document.getElementById('vid');
        const {backgroundProcessingPercentage, analysisProgress} = this.state
        const {backgroundProcessing} = this.props
        if (backgroundProcessingPercentage) {
            percentage = backgroundProcessingPercentage;
        } else if (video) {
            let videoDuration = video.duration
            let currentTime = this.videoElement.current && this.videoElement.current.currentTime
            if (!isNaN(videoDuration)) {
                percentage = (currentTime / videoDuration) * 100
            }
        }

        let title = "";
        if (this.props.videoAnalyzeForLiveStream) {
            percentage = 100
            title = getString("analyzing")
        } else if (this.props.videoFile && !this.props.previewMode && analysisProgress.stage) {
            title = analysisProgress.mode === 'batched' && analysisProgress.batchCount > 0
                ? getAnalysisString(
                    "analysis_batch_label",
                    `Batch ${analysisProgress.batchIndex + 1} of ${analysisProgress.batchCount}`,
                    `バッチ ${analysisProgress.batchIndex + 1} / ${analysisProgress.batchCount}`
                )
                : getString("processing_video")
        } else if (percentage === 0) {
            title = getString("start_video_analyze")
        } else if (backgroundProcessing) {
            title = `${getString("processing_video")} ${backgroundProcessingPercentage}%`
        }

        if (this.props.previewMode) {
            title = getString("preview")
        }

        return (<Footer>
            <LoaderTitle>
                {title}
            </LoaderTitle>
            <Loader progress={`${(this.progressLimit(0, percentage, 100) / 100) * 100}%`}
                    style={this.props.previewMode ? {backgroundColor: colors.lipstick} : null}/>
        </Footer>)
    }

    progressLimit = (min, value, max) => {
        return Math.min(Math.max(min, value), max);
    }

    updateInput = (input) => {
        this.setState({input})
    }

    streamStarted = async () => {
        const {input, streamReady} = this.state
        console.log("streamStarted", input)
        if(streamReady){
            return
        }
        let currentTime = this.videoElement.current && this.videoElement.current.currentTime
        console.log("warmupOffset", currentTime)
        this.setState({streamReady: true, countingDown: false, warmupOffset: currentTime})
       // this.detectEmotions()
       // this.startCountDown()

    }

    warmup = (input) => {
        console.log("warmup")
        this.setState({countingDown: true, input},()=>{
                this.detectEmotions()
            })
    }

    previewStarted = async () => {
        const {tracker} = this.props

        console.log("previewStarted", tracker)

    }

    formatEta = (seconds) => {
        if (!Number.isFinite(seconds) || seconds < 0) {
            return null;
        }

        const roundedSeconds = Math.max(0, Math.round(seconds));
        const isJapanese = translations.selectedLocale === "ja";

        if (roundedSeconds < 60) {
            return isJapanese ? `${roundedSeconds}秒` : `${roundedSeconds}s`;
        }

        const hours = Math.floor(roundedSeconds / 3600);
        const minutes = Math.floor((roundedSeconds % 3600) / 60);
        const remainingSeconds = roundedSeconds % 60;

        if (hours > 0) {
            return isJapanese ? `${hours}時間 ${minutes}分` : `${hours}h ${minutes}m`;
        }

        return isJapanese ? `${minutes}分 ${remainingSeconds}秒` : `${minutes}m ${remainingSeconds}s`;
    }

    getAnalysisHeadline = (progress) => {
        if (progress.mode === 'batched') {
            if (progress.stage === 'loading') {
                return getAnalysisString("analysis_preparing_batch_processing", "Preparing batch processing...", "バッチ処理を準備しています...");
            }
            return getAnalysisString("analysis_processing_video_batches", "Processing video in batches", "動画をバッチ処理しています");
        }

        if (progress.stage === 'loading') {
            return getAnalysisString("analysis_preparing_video_analysis", "Preparing video analysis...", "動画分析を準備しています...");
        }

        return getAnalysisString("analysis_processing_video", "Processing video", "動画を処理しています");
    }

    getAnalysisSubStatus = (progress) => {
        if (progress.stage === 'loading') {
            return getAnalysisString("analysis_loading_video_processor", "Loading video processor...", "動画処理ツールを読み込んでいます...");
        }

        if (progress.stage === 'extracting') {
            return progress.mode === 'batched'
                ? getAnalysisString("analysis_extracting_batch_frames", "Extracting frames for this batch", "このバッチのフレームを抽出しています")
                : getAnalysisString("analysis_extracting_frames", "Extracting frames", "フレームを抽出しています");
        }

        if (progress.stage === 'analyzing') {
            return getAnalysisString("analysis_analyzing_extracted_frames", "Analyzing extracted frames", "抽出したフレームを分析しています");
        }

        return getAnalysisString("analysis_preparing", "Preparing...", "準備しています...");
    }

    renderAnalysisProgress = () => {
        const { analysisProgress, backgroundProcessingPercentage } = this.state;
        const {
            mode,
            stage,
            frameIndex,
            totalFrames,
            batchIndex,
            batchCount,
            batchFrameIndex,
            batchFrameCount,
            batchEtaSec,
            overallEtaSec,
            ffmpegSpeed,
        } = analysisProgress;

        const headline = this.getAnalysisHeadline(analysisProgress);
        const subStatus = this.getAnalysisSubStatus(analysisProgress);
        const batchLabel = mode === 'batched' && batchCount > 0
            ? getAnalysisString(
                "analysis_batch_label",
                `Batch ${batchIndex + 1} of ${batchCount}`,
                `バッチ ${batchIndex + 1} / ${batchCount}`
            )
            : null;
        const frameLabel = totalFrames > 0 && stage === 'analyzing'
            ? getAnalysisString(
                "analysis_frame_label",
                `Frame ${Math.min(frameIndex + 1, totalFrames)} of ${totalFrames}`,
                `フレーム ${Math.min(frameIndex + 1, totalFrames)} / ${totalFrames}`
            )
            : null;
        const batchFrameLabel = mode === 'batched' && batchFrameCount > 0
            ? getAnalysisString(
                "analysis_batch_frame_label",
                `${Math.min(batchFrameIndex, batchFrameCount)} of ${batchFrameCount} frames in this batch`,
                `このバッチ: ${Math.min(batchFrameIndex, batchFrameCount)} / ${batchFrameCount} フレーム`
            )
            : null;
        const batchEtaLabel = this.formatEta(batchEtaSec);
        const totalEtaLabel = this.formatEta(overallEtaSec);

        const pct = Math.min(backgroundProcessingPercentage, 100);

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                gap: 20,
                padding: '40px 60px',
            }}>
                <img
                    src={getAsset("loader.svg")}
                    alt="processing"
                    style={{ width: 60, height: 60 }}
                />
                <div style={{
                    fontSize: 22,
                    color: '#536EEC',
                    fontWeight: 700,
                    fontFamily: 'Open Sans',
                    textAlign: 'center',
                }}>
                    {headline}
                </div>
                {batchLabel && (
                    <div style={{
                        fontSize: 15,
                        color: '#6B7AAA',
                        fontWeight: 600,
                        fontFamily: 'Open Sans',
                        textAlign: 'center',
                    }}>
                        {batchLabel}
                    </div>
                )}
                <div style={{
                    fontSize: 14,
                    color: '#8A96B8',
                    fontWeight: 600,
                    fontFamily: 'Open Sans',
                    textAlign: 'center',
                }}>
                    {subStatus}
                </div>
                <div style={{ width: '100%', maxWidth: 400 }}>
                    <div style={{
                        width: '100%',
                        height: 8,
                        background: '#E8ECF8',
                        borderRadius: 4,
                        overflow: 'hidden',
                    }}>
                        <div style={{
                            height: '100%',
                            width: `${pct}%`,
                            background: '#536EEC',
                            borderRadius: 4,
                            transition: 'width 0.3s ease',
                        }} />
                    </div>
                    <div style={{
                        marginTop: 6,
                        textAlign: 'center',
                        fontSize: 13,
                        color: '#9BA8D0',
                        fontFamily: 'Open Sans',
                    }}>
                        {pct}%
                    </div>
                </div>
                <div style={{
                    width: '100%',
                    maxWidth: 420,
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 12,
                }}>
                    <div style={{
                        background: '#F3F6FF',
                        borderRadius: 12,
                        padding: '12px 14px',
                        textAlign: 'center',
                        fontFamily: 'Open Sans',
                    }}>
                        <div style={{ fontSize: 12, color: '#8A96B8', marginBottom: 4 }}>
                            {getAnalysisString("analysis_current_batch", "Current batch", "現在のバッチ")}
                        </div>
                        <div style={{ fontSize: 15, color: '#536EEC', fontWeight: 700 }}>
                            {batchEtaLabel
                                ? getAnalysisString("analysis_batch_eta_left", `Approx. ${batchEtaLabel} left`, `残り約 ${batchEtaLabel}`)
                                : getAnalysisString("analysis_estimating", "Estimating...", "推定中...")}
                        </div>
                    </div>
                    <div style={{
                        background: '#F3F6FF',
                        borderRadius: 12,
                        padding: '12px 14px',
                        textAlign: 'center',
                        fontFamily: 'Open Sans',
                    }}>
                        <div style={{ fontSize: 12, color: '#8A96B8', marginBottom: 4 }}>
                            {getAnalysisString("analysis_total_remaining", "Total remaining", "合計残り時間")}
                        </div>
                        <div style={{ fontSize: 15, color: '#536EEC', fontWeight: 700 }}>
                            {totalEtaLabel
                                ? getAnalysisString("analysis_total_eta", `Approx. ${totalEtaLabel}`, `約 ${totalEtaLabel}`)
                                : getAnalysisString("analysis_estimating", "Estimating...", "推定中...")}
                        </div>
                    </div>
                </div>
                {(frameLabel || batchFrameLabel || ffmpegSpeed) && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6,
                        alignItems: 'center',
                        color: '#8A96B8',
                        fontSize: 13,
                        fontFamily: 'Open Sans',
                        textAlign: 'center',
                    }}>
                        {frameLabel && <div>{frameLabel}</div>}
                        {batchFrameLabel && <div>{batchFrameLabel}</div>}
                        {stage === 'extracting' && ffmpegSpeed && (
                            <div>
                                {getAnalysisString(
                                    "analysis_ffmpeg_speed",
                                    `FFmpeg speed: ${ffmpegSpeed.toFixed(2)}x`,
                                    `FFmpeg速度: ${ffmpegSpeed.toFixed(2)}x`
                                )}
                            </div>
                        )}
                    </div>
                )}
                <div style={{
                    width: '100%',
                    maxWidth: 430,
                    background: '#FFF6E5',
                    border: '1px solid #F3C46B',
                    borderRadius: 10,
                    padding: '12px 14px',
                    color: '#8A5A00',
                    fontSize: 13,
                    lineHeight: 1.45,
                    fontFamily: 'Open Sans',
                    textAlign: 'center',
                }}>
                    <strong>
                        {getAnalysisString("analysis_keep_tab_visible_title", "Keep this tab visible", "このタブを表示したままにしてください")}
                    </strong>
                    <div style={{ marginTop: 4 }}>
                        {getAnalysisString(
                            "analysis_keep_tab_visible_message",
                            "Switching tabs, minimizing the browser, or closing this page can stop or significantly slow the analysis.",
                            "タブを切り替えたり、ブラウザを最小化したり、このページを閉じたりすると、分析が停止するか大幅に遅くなる可能性があります。"
                        )}
                    </div>
                </div>
            </div>
        );
    }

    updateBackgroundProcessing = (progressInfo = {}) => {
        const {
            stage,
            frameIndex = 0,
            totalFrames = 0,
            currentTime = 0,
            duration = 0,
            overallProgressPct,
        } = progressInfo;
        let pct = 0;
        if (Number.isFinite(overallProgressPct)) {
            pct = Math.round(overallProgressPct);
        } else if (stage === 'analyzing' && totalFrames > 0) {
            pct = Math.round(((frameIndex + 1) / totalFrames) * 100);
        } else if (duration > 0) {
            pct = Math.round((currentTime / duration) * 100);
        }
        this.setState({
            backgroundProcessingPercentage: pct,
            analysisProgress: {
                ...createInitialAnalysisProgress(),
                ...progressInfo,
                stage: stage || null,
                frameIndex,
                totalFrames,
                currentTime,
                duration,
                overallProgressPct: pct,
            },
        });
    }



    render() {

        const {videoSrc, showFaceLandmarks, streamReady, countDown, countingDown} = this.state
        const {setVideoTracker, tracker, height, videoAnalyzeForLiveStream, previewMode} = this.props

        let imageWidth, imageHeight, detectionSquareTop, detectionSquareLeft

        if (this.videoElement.current) {
            imageWidth = this.videoElement.current.offsetWidth
            imageHeight = this.videoElement.current.offsetHeight
            detectionSquareTop = this.videoElement.current.offsetTop
            detectionSquareLeft = this.videoElement.current.offsetLeft
        }
        let videoMaxHeight = "100%"
        if (height) {
            videoMaxHeight = height * .75 - 20 - 45 - 60
        }

        // let canvasLeft = 0;
        let canvasTop = 0;
        let vidDims = {}

        let vid = document.getElementById('myVideo')
        if (videoAnalyzeForLiveStream && !previewMode) {
            vid = document.getElementById('videoElement')
        }
        if (vid) {
            let {width, height} = videoDimensions(vid)
            //  canvasLeft = (vid.offsetWidth - width) / 2
            canvasTop = (vid.offsetHeight - height) / 2
            vidDims = {width, height, offsetWidth: vid.offsetWidth, offsetHeight: vid.offsetHeight}
        }

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: "100%",
                // justifyContent: "space-evenly",
                paddingBottom: 60
            }}>
                {!streamReady && videoAnalyzeForLiveStream && !previewMode && !countingDown && (
                    <img style={{height: 100, width: 100, marginTop: "33%", marginLeft: "43%"}} src={getAsset("loader.svg")} alt={"loading..."}/>
                )}
                <VideoContainer>

                    {this.props.videoFile && !previewMode
                        ? this.renderAnalysisProgress()
                        : videoAnalyzeForLiveStream && !previewMode
                            ? null
                            : videoSrc && <video
                                id="vid"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: videoMaxHeight,
                                }}
                                controls={previewMode}
                                autoPlay={false}
                                src={videoSrc}
                                ref={this.videoElement}
                                crossOrigin='anonymous'
                            />
                    }
                    {videoAnalyzeForLiveStream && !previewMode && (
                        <VideoStream
                            streamSuccessHandler={this.streamStarted}
                            width={"100%"}
                            maxHeight={videoMaxHeight}
                            updateInput={this.updateInput}
                            innerRef={this.videoElement}
                            onRecordUpdate={(recordedChunks) => {
                                if(countingDown){
                                    return;
                                }
                                console.log("recordedChunks", recordedChunks)
                                let recordedVideoChunks = this.state.recordedVideoChunks.concat(recordedChunks);
                                this.onRecordingComplete(recordedVideoChunks)

                            }}
                            shouldRecord={true}
                            countDown={true}
                            warmup={this.warmup}
                        />
                    )}
                    <canvas id={"canvas-overlay"} style={{
                        position: "absolute",
                        top: canvasTop,
                        width: vidDims.width || 0,
                        height: vidDims.height ? Math.max(vidDims.height - 100, 0) : 0,
                        zIndex: 99999,
                        visibility: showFaceLandmarks ? "visible" : "hidden",
                        pointerEvents: "none"
                    }}/>
                    <div style={{position: 'absolute', top: detectionSquareTop, left: detectionSquareLeft}}>
                        {this.renderDetectionSquare(imageHeight, imageWidth)}
                    </div>

                </VideoContainer>

                {this.renderOvertimeChart()}
                {this.renderFooter()}

                {!previewMode && this.isUsingBackgroundProcessing() && videoSrc && (
                    <VideoFaceDetector
                        interval={DETECTION_INTERVAL_MS}
                        src={videoSrc}
                        videoFile={this.props.videoFile}
                        onFinishDetection={async () => {
                            console.log("finish detection", tracker);
                            
                            // Let onAnalyzeEnd handle everything in the proper sequence
                            await this.onAnalyzeEnd("onFinishDetection");
                        }}
                        options={this.state.options}
                        saveResults={this.saveResults}
                        videoStarted={() => {
                            this.props.setBackgroundProcessing(true)
                        }}
                        onProgress={(progressInfo) => {
                            this.updateBackgroundProcessing(progressInfo)
                        }}
                        useMaskModel={this.props.useMaskModel}
                    />
                )}
                {this.state.showAnalysisVisibilityWarning && (
                    <Popup
                        closeOnDocumentClick={false}
                        isOpen={this.state.showAnalysisVisibilityWarning}
                        closeHandler={this.handleCloseAnalysisVisibilityWarning}
                        title={getAnalysisString("analysis_tab_hidden_warning_title", "Analysis may have paused", "分析が一時停止した可能性があります")}
                        description={getAnalysisString(
                            "analysis_tab_hidden_warning_message",
                            "This tab was hidden while video analysis was running. Please keep it selected and visible until processing finishes.",
                            "動画分析中にこのタブが非表示になりました。処理が完了するまで、このタブを選択して表示したままにしてください。"
                        )}
                        footerButtons={[{
                            label: getString("okay_button", "OK"),
                            onPress: this.handleCloseAnalysisVisibilityWarning,
                            background: colors.blue,
                        }]}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({video, house, faceId}) => ({
    tracker: video.tracker,
    currentHouse: house.currentHouse,
    faceIds: faceId.faceIds,
    faceIdCount: faceId.faceIdCount,
    selectedIds: faceId.selectedIds
});

const mapDispatchToProps = {
    setVideoTracker,
    addFaceId,
    selectId,
    updateFaceIdCount,
    resetFaceId,
};

Video.propTypes = {
    previewMode: PropTypes.bool,
    detectionInterval: PropTypes.number,
}

Video.defaultProps = {
    previewMode: false,
    detectionInterval: 500,
}

export default connect(mapStateToProps, mapDispatchToProps)(Video);

const VideoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 75%;
    position: relative;
`

const OverTimeContainer = styled.div`
    width: 100%;
    height: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 3px;
    padding-right: 3px;
`

const OverTimeButton = styled.button`
    background: #909090;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    // padding-left: 10px;
    // padding-right: 10px;

    font-family: Open Sans;
    font-weight: 900;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
    width: 92px;
    height: 20px;

    color: #FFFFFF;
    cursor: pointer;
    border: 0;
    outline: 0;
`

const LoaderTitle = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000247;
    text-transform: capitalize;
`

const Loader = styled.div`
    height: 40px;
    width: ${props => props.progress};
    background: #536EEC;
    transition: width 900ms;
    border-bottom-right-radius: 9px;
`

const Footer = styled.div`
    width: 100.3%;
    bottom: 0;
    left: 0;
    height: 40px;
    margin: -1px;
    position: absolute;
`
